export class UNAndReset {
    constructor(public UN?, public recoveryKey?, public email?, public Pwd?, public successEmailSend?) { }
}